<script>
  import ApplicationState from "../../../../../Stores/applicationStates"
  import notify from "../../../../../Script/notify"
  import DeleteConfirmation from "../../Shared/deleteConfirmation.svelte"
  import DuplicateConfirmation from "../../Shared/duplicateConfirmation.svelte"
  import { afterUpdate, createEventDispatcher } from "svelte"
  import { loadTooltip } from "../../../../../Script/loadTooltip"
  import { deleteRequest, getRequest, patchRequest, postRequest } from "../../../../../Script/apiMethods"
  const dispatch = createEventDispatcher()
  export let template = {}
  export let showLoading
  // export let emailCount
  export let loadingText
  export let count

  /**
   * @type {Boolean} for showing the Delete Email Template Confirmation Modal
   */
  let showDeleteModal = false

  /**
   * @type {Boolean} whether to show duplicate modal or not
   */
  let showDuplicateModal = false
  /**
   * @typedef {Object} notification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notification}
   */
  let notification = {
    close() {},
  }

  /**
   * @type {fetchDocNotification}
   */
  let fetchDocNotification = {
    close() {},
  }

  /**
   * @type {createDocNotification}
   */
  let createDocNotification = {
    close() {},
  }

  /**
   * @description function to delete particular email template based on its id
   */
  const deleteTemplate = async () => {
    try {
      showDeleteModal = false
      loadingText = "Deleting&nbsp;<strong>Email Template</strong>&nbsp;"
      showLoading = true

      await deleteRequest(`/api/swagger/v2/templates/emails/${template.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      dispatch("fetchList")

      notify.success(`Email Template <strong style="hyphens: auto;">${template.name}</strong> successfully <strong>deleted</strong>`)
    } catch (error) {
      notification.close()
      const info = "PAGE: Email template list\nEVENT: While deleting email template"
      notification = notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  const duplicateTemplate = async () => {
    try {
      showDuplicateModal = false
      loadingText = `Duplicating&nbsp;<strong>${template.name} Email Template</strong>&nbsp;`
      showLoading = true

      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      // Fetching email template details
      const { template: emailData } = await getRequest(`/api/swagger/v2/templates/emails/${template.id}`, CONFIG)

      const { templates } = await getRequest(`/api/swagger/v2/templates/emails?limit=${count}&page=1&sort=-1&sortBy=date`, CONFIG)

      let tempArray = templates.filter((email) => email.name.includes(`${emailData.name}`))

      let copyCount = 0
      for (let i = 0; i < tempArray.length; i++) {
        if (emailData.name.length + 4 == tempArray[i].name.length) copyCount++
      }
      // console.log(copyCount)

      let tempValue = ` ${copyCount ? `(${copyCount + 1})` : `(1)`}`

      // let tempValue = ` ${tempArray.length ? `(${tempArray.length + 1})` : `(1)`}`

      let remainingLength = 30 - tempValue.length

      // Make sure the emailData.name doesn't exceed the remaining length
      let truncatedName = emailData.name.slice(0, remainingLength)

      let templateName = truncatedName + tempValue

      let { created, modified, ...filteredData } = emailData

      let reqBody = { ...filteredData, name: templateName }

      // console.log(reqBody.document)

      let dublicateDocData = await duplicateDocTemplate(reqBody.document)

      // console.log(dublicateDocData)
      reqBody.document = dublicateDocData.id

      // Create email template
      const { template: newTemplate } = await postRequest("/api/swagger/v2/templates/emails", reqBody, CONFIG)

      dublicateDocData.email = newTemplate.id
      // console.log(dublicateDocData)

      // Update document template
      await patchRequest(`/api/swagger/v2/templates/documents/${dublicateDocData.id}`, dublicateDocData, CONFIG)

      dispatch("fetchList")

      notify.success(`<strong>${newTemplate.name}</strong> created successfully.`)
    } catch (error) {
      const info = "PAGE: Email template list\nEVENT: While duplicating email template"
      // Show an error notification
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  const duplicateDocTemplate = async (id) => {
    try {
      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      // Create Document template
      const { template: documentData } = await getRequest(`/api/swagger/v2/templates/documents/${id}`, CONFIG)
      // console.log(documentData)

      const { templates } = await getRequest(`/api/swagger/v2/templates/documents?limit=${count}&page=1`, CONFIG)
      // console.log(documentList)

      let tempArray = templates.filter((document) => document.name.includes(`${documentData.name}-Copy`))

      // console.log(tempArray)

      let tempValue = `-Copy-${tempArray.length ? tempArray.length + 1 : 1}`

      let remainingLength = 30 - tempValue.length

      // Make sure the documentData.name doesn't exceed the remaining length
      let truncatedName = documentData.name.slice(0, remainingLength)

      let templateName = truncatedName + tempValue

      let { created, ...filteredData } = documentData

      let reqBody = { ...filteredData, name: templateName }

      reqBody.file = ""
      reqBody.email = ""

      // console.log(reqBody)

      // Create document template
      const { template: docTemplate } = await postRequest("/api/swagger/v2/templates/documents", reqBody, CONFIG)

      return docTemplate
    } catch (error) {
      const info = "PAGE: Email template list\nEVENT: While duplicating document template"
      // Show an error notification
      notify.danger(error, info)
    }
  }

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

{#if showDeleteModal}
  <DeleteConfirmation
    on:click={() => {
      showDeleteModal = false
    }}
    {template}
    on:delete={deleteTemplate}
  />
{/if}

{#if showDuplicateModal}
  <DuplicateConfirmation
    on:click={() => {
      showDuplicateModal = false
    }}
    on:duplicate={duplicateTemplate}
    templateName={template.name}
  />
{/if}

<div class="flex w-full justify-between rounded-md border-2 border-transparent bg-white p-3 hover:shadow-md dark:bg-lightgray dark:hover:border-blue-500">
  <div class="flex select-none flex-col truncate pl-2">
    <h2 title={template.name} class="truncate text-sm font-bold text-gray-d00 dark:text-white/70 md:text-lg">
      {template.name}
    </h2>
    <h2 class="truncate text-xs font-medium text-gray-500 md:text-sm">
      <!-- {new Date(template.created).toString().slice(0, 24)} -->
      {new Date(template.modified || template.created).toString().slice(0, 24)}
    </h2>
  </div>
  <div class="flex items-center justify-end px-3">
    <a name="tooltip" id="Edit" tooltip-position="top" style="text-decoration: none;" href="#/templates/email/edit?id={template.id}" class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-yellow-500 hover:bg-yellow-500 hover:text-white focus:outline-none active:text-white peer-hover:text-white sm:px-5">
      <i class="fa-solid fa-pen-field" />
      <span class="hidden lg:block">&nbsp;&nbsp;Edit</span>
    </a>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <button
      name="tooltip"
      id="Duplicate"
      tooltip-position="top"
      on:click={() => {
        showDuplicateModal = true
      }}
      class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-emerald-500 hover:bg-emerald-500 hover:text-white focus:outline-none active:bg-emerald-400 active:text-white md:px-5 xl:w-32"
    >
      <i class="fa-solid fa-clone" />
      <span class="hidden lg:block">&nbsp;&nbsp;Duplicate</span>
    </button>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      name="tooltip"
      id="Delete"
      tooltip-position="top"
      on:click={() => {
        showDeleteModal = true
      }}
      class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-red-500 hover:bg-red-500 hover:text-white focus:outline-none active:text-white sm:px-5"
    >
      <i class="fa-solid fa-trash-can" />
      <span class="hidden lg:block">&nbsp;&nbsp;Delete</span>
    </div>
  </div>
</div>
